//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <div>
    <TitleSubtitle
      :title="page.title"
      :subtitle="page.subtitle"
      :titleColor="store.state.Style.themeColor"
      :titleStyle="{ color: store.state.Style.themeColor }"
      :subtitleStyle="{ fontWeight: 300 }"
    />
    <div class="go_icon_container">
      <component :is="icon" />
    </div>
  </div>
</template>
<script setup>
import TitleSubtitle from "@/components/TitleSubtitle.vue";
import CircleSpinner from "@/components/loaders/CircleSpinner.vue";
import PhoneOutline from "@/components/icons/PhoneOutlineIcon.vue";

import { useStore } from "vuex";
import { defineProps, ref, computed, onMounted } from "vue";

const props = defineProps(["page"]);

const store = useStore();
const showIcon = ref(false);

const icon = computed(function () {
  const components = {
    CircleSpinner,
    PhoneOutline,
  };

  if (!showIcon.value && props.page.useLoader) {
    return components[props.page.loader];
  }
  return components[props.page.icon.value];
});

onMounted(function () {
  setTimeout(() => {
    showIcon.value = true;
  }, 3000);
});
</script>

<style lang="scss" scoped>
.go_section {
  margin-top: -20%;

  .go_icon_container {
    position: relative;
    height: 220px;
    width: 200px;
    margin-top: 30px;
  }
}
</style>
